const baseTitle = {
  textTransform: "uppercase",
  textAlign: "left",
  color: "primary.main",
};

export const styles = {
  title: {
    ...baseTitle,
    fontWeight: "bold",
    fontSize: 18,
  },
  subtitle: {
    ...baseTitle,
    fontWeight: "medium",
    fontSize: 16,
    color: "secondary.main",
  },
  subtitle2: {
    ...baseTitle,
    fontWeight: "medium",
    fontSize: 14,
  },
  infoText: {
    fontSize: 14,
    color: "text.secondary",
    textAlign: "left",
    margin: 0,
  },
  poppinsTitle: {
    fontFamily: "Poppins, sans-serif",
    color: "primary.main",
    fontWeight: 600,
    textAlign: "center",
  },
};
